<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
      <v-toolbar flat outlined>
        <v-btn icon :link="false" @click="back">
          <v-icon>fa-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Detalles Licencia</v-toolbar-title>
      </v-toolbar>
      <v-container grid-list-md fluid>
        <v-layout row wrap>
          <v-flex xs12 sm3 md3 style="display: none">
            <v-text-field
              disabled
              v-model="licencia_info.id"
              label="id"
            />
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-text-field class="my-0 py-0"
              v-model="licencia_info.folio"
              label="Folio"
              readonly
            />
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-text-field class="my-0 py-0"
              v-model="licencia_info.n_vivienda"
              label="Vivienda"
              readonly
           />
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-text-field class="my-0 py-0"
              v-model="tipo_licencia"
              label="Tipo"
              readonly
            />
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-text-field class="my-0 py-0"
              v-model="licencia_info.nombre_conductor"
              label="Nombre Completo"
              readonly
            />
          </v-flex>
          <v-flex xs12 sm2 md2>
            <v-text-field class="my-0 py-0"
              v-model="licencia_info.vigencia"
              label="Vigente Hasta"
              readonly
            />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </template>
<script>
export default {
  components: {
  },
  data: () => ({
    licencia_info: {},
    folio: '',
    tipo: '',
    vivienda: '',
    nombre: '',
  }),
  computed: {
    is_loading() {
      return this.$store.getters['detallesLicencia/is_loading'];
    },
    licencia_processing() {
      return this.$store.getters['detallesLicencia/licencia_processing'];
    },
    tipo_licencia() {
      if (this.licencia_info.residente_id === null) {
        return 'DOMÉSTICO';
      }
      return 'RESIDENTE';
    },
  },
  watch: {
  },
  methods: {
    back() {
      this.$router.back();
    },
    clear_null(value) {
      let tmpNull = null;
      if (typeof value === 'string') {
        if (value === 'None') {
          tmpNull = '';
        } else {
          tmpNull = value.trim();
        }
      } else if (value === null || typeof value === 'undefined') {
        tmpNull = '';
      } else {
        tmpNull = value;
      }
      return tmpNull;
    },
  },
  created() {
  },
  mounted() {
    this.$store.dispatch('detallesLicencia/fetchLicenciaInfo', this.$route.params.id)
      .then((data) => {
        this.licencia_info = data.licencia;
        console.log(this.licencia_info);
      });
  },
};
</script>
